import { render, staticRenderFns } from "./DivTable.vue?vue&type=template&id=7008c8af&scoped=true&"
import script from "./DivTable.vue?vue&type=script&lang=js&"
export * from "./DivTable.vue?vue&type=script&lang=js&"
import style0 from "./DivTable.vue?vue&type=style&index=0&id=7008c8af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7008c8af",
  null
  
)

export default component.exports